import { ReactElement } from 'react';
import { EditOrderI } from './editOrder';
import EditOrderMobileOrder from './editOrderMobileOrder';

const EditOrderMobile = ({
  handleClose,
  handleSaveOrderInformation,
  orderRegisteredFields,
  errors,
  handleChangeTestType,
  currentValueTestType,
  testTypes,
}: EditOrderI): ReactElement => {
  return (
    <EditOrderMobileOrder
      handleClose={handleClose}
      handleSaveOrderInformation={handleSaveOrderInformation}
      orderRegisteredFields={orderRegisteredFields}
      errors={errors}
      handleChangeTestType={handleChangeTestType}
      currentValueTestType={currentValueTestType}
      testTypes={testTypes}
    />
  );
};

export default EditOrderMobile;
